module.exports = __webpack_public_path__ + "static/img/report_bg1.c6b5b535.png";